var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.25C6.37665 0.25 4.25 2.37665 4.25 5V5.25H1C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75H17C17.4142 6.75 17.75 6.41421 17.75 6C17.75 5.58579 17.4142 5.25 17 5.25H13.75V5C13.75 2.37665 11.6234 0.25 9 0.25ZM9 1.75C10.7949 1.75 12.25 3.20507 12.25 5V5.25H5.75V5C5.75 3.20507 7.20507 1.75 9 1.75Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74664 7.92906C2.70746 7.5167 2.34142 7.21418 1.92906 7.25336C1.5167 7.29254 1.21418 7.65858 1.25336 8.07094C1.34783 9.06522 1.51833 10.2903 1.73748 11.8651L2.01903 13.8881C2.28819 15.8229 2.44085 16.9201 2.77109 17.819C3.3857 19.4918 4.48205 20.8328 5.89206 21.4278C6.65773 21.7509 7.53352 21.7506 8.83733 21.75H9.16267C10.4665 21.7506 11.3423 21.7509 12.1079 21.4278C13.5179 20.8328 14.6143 19.4918 15.2289 17.819C15.5592 16.9201 15.7118 15.8229 15.981 13.8881L16.2625 11.8651C16.4817 10.2903 16.6522 9.06522 16.7466 8.07094C16.7858 7.65858 16.4833 7.29254 16.0709 7.25336C15.6586 7.21418 15.2925 7.5167 15.2534 7.92906C15.1623 8.88702 14.9965 10.08 14.7744 11.6761L14.512 13.5611C14.2215 15.6488 14.0884 16.5736 13.8209 17.3017C13.305 18.7058 12.4472 19.6566 11.5248 20.0458C11.0746 20.2358 10.5292 20.25 9 20.25C7.47083 20.25 6.92544 20.2358 6.47524 20.0458C5.55279 19.6566 4.69496 18.7058 4.17907 17.3017C3.91156 16.5736 3.77851 15.6488 3.48798 13.5611L3.22564 11.6761C3.00352 10.08 2.83766 8.88703 2.74664 7.92906Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 9C7.75 8.58579 7.41421 8.25 7 8.25C6.58579 8.25 6.25 8.58579 6.25 9V17C6.25 17.4142 6.58579 17.75 7 17.75C7.41421 17.75 7.75 17.4142 7.75 17V9Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 9C11.75 8.58579 11.4142 8.25 11 8.25C10.5858 8.25 10.25 8.58579 10.25 9V17C10.25 17.4142 10.5858 17.75 11 17.75C11.4142 17.75 11.75 17.4142 11.75 17V9Z",
    fill: "#111111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.0964c2a7f39bd36c5a8891ce3c500fce.svg";
export { ForwardRef as ReactComponent };